import React, { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';

import CopyToolModal from 'components/CopyToolModal';
import { useWarnWhileCopying } from 'components/CopyToolModal/useWarnWhileCopying';

import { getIsCopyToolOpen } from '../../redux/selectors/CopyToolSelectors';

import Footer from './Footer';
import Header from './Header';
import LeftNavRail from './LeftNavRail';

interface ILayoutProps {
  children: ReactNode;
  showFooter?: boolean;
  hideHeader?: boolean;
  hideLeftNav?: boolean;
  /** Passed to Header — see its `transparentOnDesktop`. */
  transparentHeader?: boolean;
}

const Layout: React.FC<ILayoutProps> = ({
  children,
  showFooter = true,
  hideHeader = false,
  hideLeftNav = false,
  transparentHeader = false,
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isCopyToolOpen = useSelector(getIsCopyToolOpen);
  useWarnWhileCopying();

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);
  const closeMobileMenu = () => setMobileMenuOpen(false);

  return (
    <div className="relative flex min-h-screen">
      {!hideLeftNav && (
        <div>
          <LeftNavRail
            mobileMenuOpen={mobileMenuOpen}
            onClose={closeMobileMenu}
          />
        </div>
      )}
      {/* min-w-0 lets the page area shrink to the window, so wide content
          (a grid, a table) scrolls inside its own area instead of pushing
          the whole page wider than the screen. */}
      <div className="min-w-0 flex-1">
        {!hideHeader && (
          <Header
            onMenuToggle={toggleMobileMenu}
            transparentOnDesktop={transparentHeader}
          />
        )}
        <main
          className={`${hideHeader ? '' : 'pt-16 md:pt-0'} ${
            hideLeftNav ? '' : 'md:pl-16'
          }`}
        >
          {children}
        </main>
        {showFooter && <Footer />}
      </div>
      {isCopyToolOpen && <CopyToolModal />}
    </div>
  );
};

export default Layout;
